module.exports = __webpack_public_path__ + "static/media/lupa.d4416963.svg";